import { IApplicationState, TBoardId } from '../../../../../../types/types';

export const getIsShareHintShow = (
    state: IApplicationState,
    boardId: TBoardId
): boolean => {
    return state.topBar[boardId] && state.topBar[boardId].isShareHintShow;
};
